import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import AddOrganizationMemberTrigger from './addOrganizationMembers/AddOrganizationMembersTrigger';
import AddOrganizationMembersContent from './addOrganizationMembers/AddOrganizationMembersContent';

import * as userSearchSelectors from '../../selectors/userSearchSelectors';

const AddOrganizationMembers = ({ isAddMember }) => {
    if (isAddMember) {
        return <AddOrganizationMembersContent />;
    }

    return <AddOrganizationMemberTrigger />;
};

AddOrganizationMembers.propTypes = {
    isAddMember: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
    isAddMember: userSearchSelectors.isAddMember(state),
});

export default connect(
    mapStateToProps,
    undefined,
)(AddOrganizationMembers);



// WEBPACK FOOTER //
// ./src/containers/organizationMembers/AddOrganizationMembers.js